import { Component, OnInit, ElementRef, OnDestroy, NgZone, Input, HostListener } from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

// Leaflet
import { latLng, MapOptions, Marker } from 'leaflet';
import * as L from 'leaflet';

import { IWayPoint } from '../itinenary-list/itinerary';
import { IBaseMap } from './map';
import { IMapSettings } from '../../map-settings/settings';
import { MapProvider } from './map-utils/map-providers';
import { ConfirmDialogComponent } from '../../../shared/confirm-dialog/confirm-dialog.component';

// Services
import { SettingService } from '../../services/setting.service';
import { MapDataService } from '../services/map-data.service';
import { FileDataService } from '../services/file-data.service';
import { MapMarkerService } from '../services/map-marker.service';
import { MapSharedService } from '../services/map-shared.service';
import { AuthService } from 'src/app/user/services/auth.service';
import { UserService } from '../../../user/services/user.service';

//dialogs
import { MapSettingsDialog } from '../../map-settings/map-settings.dialog';
import { element } from 'protractor';
import { FileExportSaveLocallyComponent } from '../file-import/file-export.save.locally.component';

@Component({
  selector: 'app-render-map',
  templateUrl: './render-map.component.html',
  styleUrls: ['./render-map.component.scss']
})
export class RenderMapComponent implements OnInit, OnDestroy {
  @Input() coordinates: { latitude: number, longitude: number }
  map: L.Map;
  markerList: Marker[] = [];
  mapOptions: MapOptions;
  itinenaryDataSource = new BehaviorSubject<IWayPoint[]>([]);
  itineraryToBeAdded: IWayPoint;
  currentItineraryDetails: IWayPoint[] = [];
  mapSettings: IMapSettings;
  popUpContent: string = '';
  tooltipContent: string = '';
  enablePrompt: boolean = false;
  //draging issue
  isValidMarkerDate: boolean = false;

  // Subscription List
  subs: Subscription[] = [];

  baseMapProvider: MapProvider;
  baseMapTileLayer: L.TileLayer | L.LayerGroup;
  selectedMapLayer: IBaseMap = {
    name: '[Map] Tomtom Routes',
    layerName: 'Tomtom Routes',
    type: 'Map'
  };
  mapLayersList: IBaseMap[];
  selectedmapLayersList: IBaseMap[];
  selectedMarker: any;

  timed :boolean = false;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
   countdown:any;
  // currentUsername:any;
   mapCopyRight : string="";
   hrefs:string="";
   saveStatus: 'Success' | 'Failed' | null = null; // Status of the autoSave API result

  constructor(
    private readonly ngZone: NgZone,
    private router: Router,
    private confirmDialog: MatDialog,
    private settingService: SettingService,
    private mapService: MapDataService,
    private sharedService: MapSharedService,
    private fileService: FileDataService,
    private hostElement: ElementRef,
    private settingsDialog: MatDialog,
    private mapMarker: MapMarkerService,
    private userService:UserService,
    private authService: AuthService,
    private exportDialog : MatDialog,) {
    this.baseMapProvider = new MapProvider();
    this.baseMapTileLayer = this.baseMapProvider.getBaseMapLayer(this.selectedMapLayer);
    if(this.selectedMapLayer.name=="[Map] Tomtom Routes"){
     this.mapCopyRight=" Copyright © 2016 TomTom International BV. All rights reserved."

    }
    }  

  ngOnInit() {
    this.initializeMapOptions(this.coordinates.latitude, this.coordinates.longitude);
    this.getCurrentItineraryDetails();
    this.getSavedMapSettings();
  // this.getAllLoginUsers();
    //draging issue
    this.subs.push(this.fileService.isValidMark$.subscribe(
      (data) => {
        this.isValidMarkerDate = data;
        //console.log("isValidMarkerDate "+ this.isValidMarkerDate)
      }
    ));

    this.subs.push(this.fileService.dragChange$.subscribe(data => {
      if (data) {
        this.getCoordinatesOnClick(data, true);
      }
    }
    ));
    this.subs.push(this.fileService.selectrdMarker$.subscribe(marker => {
      if (marker) {
        const itineraryLatLongList = this.sharedService.getLatLongList(this.currentItineraryDetails);
        if(this.fileService.isItineraryListMarker){
          itineraryLatLongList.forEach((element)=>{
            if(element.lat==marker.latitude && element.lng==marker.longitude)
              this.selectedMarker=marker.id-1;
          })
          this.fileService.isItineraryListMarker=false;
        }
        else{
          const selectedMatker = marker.getLatLng();
          this.selectedMarker = itineraryLatLongList.findIndex(item => item.lat === selectedMatker.lat && item.lng === selectedMatker.lng);
        }
      }
    }
    ));

    // Subscribe to the saveStatus observable
    this.sharedService.saveStatus$.subscribe((status) => {
      this.saveStatus = status;
    });
  }

  @HostListener('document:click', ['$event.target'])
  handleDeleteClick(event) {
    if (event && event.id === 'deleteWaypoint') {
      const lat = event.getAttribute('lat');
      const lon = event.getAttribute('lon');
      this.deleteItinerary(lat, lon);
    }
  }

  deleteItinerary(lat, lon): void {
    this.itinenaryDataSource.next(this.itinenaryDataSource.getValue().filter(item => item.latitude !== lat && item.longitude !== lon));
    this.fileService.changeItinenaryData(this.itinenaryDataSource.getValue(), true);
  }

  @HostListener('focusout', ['$event.target'])
  handleEditClick(event) {
    if (event && event.id === 'editWaypointName') {
      const lat = event.getAttribute('lat');
      const lon = event.getAttribute('lon');
      const value = event.innerText;
      this.editItinerary(lat, lon, value);
    }
  }

  editItinerary(lat, lon, value): void {
    const index = this.itinenaryDataSource.getValue().findIndex(item => item.latitude === lat && item.longitude === lon);
    const newItinerary = [...this.itinenaryDataSource.getValue()];
    newItinerary[index].itineraryName = value;
    this.itinenaryDataSource.next(newItinerary);
    this.fileService.changeItinenaryData(newItinerary, true);
  }

  /**
   * Watch for any changes pushed to itinerary table data
   */
  getCurrentItineraryDetails() {
    this.subs.push(this.fileService.currentItinenary$.subscribe(
      itineraryArr => {
        this.currentItineraryDetails = itineraryArr;
        this.fileService.renameItinerary=true;
        if (this.fileService.isSelectedMarker) {
          this.selectedMarker = this.currentItineraryDetails.length - 1;
          this.fileService.isSelectedMarker = false;
        }
        this.itinenaryDataSource.next(itineraryArr);
      }
    ));
  }
  /**
   * Watch for any changes pushed to Map SETTINGS
   */
  getSavedMapSettings() {
    this.subs.push(this.settingService.currentMapSettings$.subscribe(
      (mapSettings: IMapSettings) => {
        if (mapSettings) {
          this.mapSettings = mapSettings;
          this.enablePrompt = this.mapSettings.addWayPointPrompt;
          this.generateBaseLayersList(this.mapSettings.maps);
        }
      }
    ));
  }

  /**
   * Based on the selected `map-types` options available in MAP SETTINGS
   * generate the list for base layers 
   */
  generateBaseLayersList(mapList: any) {
    this.mapLayersList=[];
    this.selectedmapLayersList = [];
    for (const map in mapList) {
      mapList[map].subMaps.forEach((subMap: any) => {
       // console.log(subMap)
        if (subMap.isSubMapSelected && subMap.isImplemented) {
          const mapName = map === 'Road' ? 'Map' : map;
          if(mapName=="Map" || mapName=="Satellite"){
          if(subMap.subMapName=="Tomtom Routes" || subMap.subMapName=="HERE MAPS" || subMap.subMapName=="ViaMichelin" || subMap.subMapName=="OpenStreetMap"){
          this.mapLayersList.push({
            name: `[${mapName}] ${subMap.subMapName}`,
            layerName: subMap.subMapName,
            type: mapName
          })
        } 
      } 
         }
      });     
    }
  }
  onBaseMapLayerChange(selectedLayer: IBaseMap) {
    switch(selectedLayer.layerName){
      case 'OpenStreetMap' : 
              this.mapCopyRight="© OpenStreetMap contributors ";
                break;
            case 'Tomtom Routes' :
                this.mapCopyRight="Copyright © 2016 TomTom International BV. All rights reserved."
                break;
            case 'ViaMichelin' :
               this.mapCopyRight="©Michelin ©TomTom ©Natural Earth."
                break;
            
            case 'HERE MAPS' :
               this.mapCopyRight="© 2016 HERE";
                break;
            case "Microsoft Bing Maps" :
              this.mapCopyRight="";
               this.mapCopyRight="© 2016 HERE, © 2016 Microsoft Corporation.";
                break;
            case 'Thunderforest' :
              this.mapCopyRight=" © Thunderforest, Data © OpenStreetMap contributors.";
                break;
            case 'OpenTopoMap' :
              this.mapCopyRight="© OpenStreetMap contributors, SRTM | map style: © OpenTopoMap (CC-BY-SA)";
                break;
            case 'ArcGIS World Map' :
              this.mapCopyRight="ArcGIS, Esri, HERE, DeLorme, NGA, USGS.";
                break;
            case 'Mappy Maps':
              this.mapCopyRight="©Mappy | 2020 TomTom.";
                break;
            case 'Waze World Map' :
              this.mapCopyRight="© 2006-2017 Waze Mobile. Tous Droits Réservés. Notices.";
                break;
            case 'Yandex Maps':
              this.mapCopyRight=" ©2014 Yandex, ©2013 NAVTEQ, © Яндекс.";
                break;
            case 'USA Topographic Maps':
              this.mapCopyRight=" © 2013 National Geographic Society.";
                 break;
            case 'Waze USA Map':
              this.mapCopyRight="© 2006-2017 Waze Mobile. Tous Droits Réservés. Notices .";
                 break;
            case 'Japan Topographic Map':
              this.mapCopyRight="Geospatial Information Authority of Japan.";
                 break;
            case 'Norway Topographic Map':
              this.mapCopyRight=" © Norgeskart.";
                 break;
            case 'Natural Resources Canada Map':
              this.mapCopyRight="Maps by NRCan.gc.ca.";
                 break;
            case 'Australian Topographic Map':     
            // this.hrefs=""        
            // this.hrefs="Geoscience Australia CC-By-Au";
              this.mapCopyRight= "Geoscience Australia CC-By-Au and Natural Earth.";
                 break;
            case 'New Zealand Topographic Map':
              this.mapCopyRight="Sourced from NZTopo Database, Crown Copyright Reserve.";
                 break; 
            case 'Grand-Duche` de Luxembourg':
              this.hrefs="" 
              this.mapCopyRight="© Grand-Duché de Luxembourg GeoPortail.";
                 break;  
           
               
    }
   
    this.baseMapTileLayer = this.baseMapProvider.getBaseMapLayer(selectedLayer);
   
  }

  compareWithMapProvider(layer1: IBaseMap, layer2: IBaseMap) {
    return layer1.name === layer2.name;
  }

  /**
   * Event Handler which triggers on click of "id=addItinerary" on Marker
   * Pushes the searchedItem to Itinerary Table based on
   * userPrompt settings available in MAP Settings
   */
  addItineraryHandler() {
    if (this.enablePrompt) {
      this.ngZone.run(() => {
        const message = "Do you want to add this location to itinerary?"
        const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
          width: '30rem',
          data: message
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result.saveData) {
            this.addToItinerary();
          } else {
            this.selectedMarker = 1;
          }
        })
      })
    } else {
      this.addToItinerary();
    }

  }

  /**
   * `itineraryToBeAdded` is added to the main <ITINERARY TABLE>
   */
  addToItinerary() {
    this.ngZone.run(() => {
      // id = 0 --> true when new item comes from search or on clicking anywhere on maps
      // id = specified index --> true when new item comes from `map-route`
      let insertIndex = 0;
      if (this.itineraryToBeAdded.id === 0) {
        // push the element at the end of ITINERARY TABLE array
        const length = this.currentItineraryDetails ? this.currentItineraryDetails.length : 1;
        insertIndex = length;
      } else {
        insertIndex = this.itineraryToBeAdded.id;
      }
      this.itineraryToBeAdded.id = insertIndex + 1;
      this.itineraryToBeAdded.sequenceId = insertIndex + 1;

      const itineraryData = [...this.currentItineraryDetails];
      itineraryData.splice(insertIndex, 0, this.itineraryToBeAdded);

      // Adjust the 'sequenceId' and 'id' after the insertion at specified index
      const modifiedItinerary = itineraryData.map((itinerary: IWayPoint, index: number) => {
        itinerary.id = itinerary.sequenceId = index + 1;
        return itinerary;
      });
      this.fileService.changeItinenaryData(modifiedItinerary, true);
      this.removeAllMarker();
    });
  }

  /**
   * Fetches Coordinates and Location Name on clicking 
   * anywhere on the Map
   */
  getCoordinatesOnClick(event: any, isDrag = false) {
    // console.log('Drag value '+ isDrag);
    //console.log("isValidMarkerDate "+this.isValidMarkerDate);
    if (!this.fileService.isDrawPolygon) {
      // `radius`  decides the perimeter within which place the coordinates
      // const radius = this.mapSettings.waypointsOnRoad ? 100 : 0;

      let x = { lat: 0, lng: 0 };
      if (isDrag) {
        x = event.getLatLng();
      } else {
        //draging issue
        //let newMark= Date.now();  
        // let bufftime= newMark - this.isValidMarkerDate;
        if (this.isValidMarkerDate == true) {
          //  console.log("stop event propagtion");
          event.stopPropagation();
          // return;
        }
        x = event.latlng;
      }
      if (this.mapSettings.waypointsOnRoad) {
        this.mapService.reverseGeocodeCoordinatesForPlaceWaypointOnRoad(x.lat, x.lng).subscribe(
          (result: any) => {
            if (result.responseStatus === 'Success') {
              this.reverseGeoCodeFunction(result.responseData.latitude, result.responseData.longitude, isDrag, event);
            } else if (result.responseCode != null && result.responseCode.statusCode === 401) {
              this.authService.logout();
              this.router.navigate(['/user/login']);
            }
          }
        );
      }
       else{
              this.reverseGeoCodeFunction(x.lat,x.lng, isDrag, event);
            }
    }
    //this.sharedService.initiateOptimiseItinerary(false);
  }
  private reverseGeoCodeFunction(lat: any, long: any, isDrag: boolean, event: any) {
    this.mapService.reverseGeocodeCoordinates(lat, long).subscribe(
      (result: any) => {
        if (result.responseStatus === 'Success') {
          if (isDrag) {
            this.selectedMarker = event.id - 1;
            this.updadteMarker(result.responseData, this.selectedMarker);
            this.isValidMarkerDate = false;
            // console.log("isValidMarkerDate "+this.isValidMarkerDate)
          } else {
            this.setMarker(true, result.responseData, event.id);//this.setMarker(true, result.responseData);
            this.placeWaypointToNearestRoute(result.responseData);

          }

        }

      }
    );
  }
  private updadteMarker(displayLocation: IWayPoint, index: number) {
    const newItinerary = [...this.itinenaryDataSource.getValue()];
    newItinerary[index].itineraryName = displayLocation.itineraryName;
    newItinerary[index].latitude = displayLocation.latitude;
    newItinerary[index].longitude = displayLocation.longitude;
    newItinerary[index].latitudeDD = displayLocation.latitudeDD;
    newItinerary[index].longitudeDD = displayLocation.longitudeDD;
    newItinerary[index].latitudeDM = displayLocation.latitudeDM;
    newItinerary[index].latitudeDM = displayLocation.latitudeDM;
    newItinerary[index].latitudeDMS = displayLocation.latitudeDMS;
    newItinerary[index].latitudeDMS = displayLocation.latitudeDMS;
    this.itinenaryDataSource.next(newItinerary);
    this.fileService.changeItinenaryData(newItinerary, true);
  }


  /**
   * Inserting the waypoint in between the existing route and
   * based on L.map.distance() method
   * @param waypoint 
   */
  placeWaypointToNearestRoute(waypoint: IWayPoint) {
    // const clickedCoordinates = this.sharedService.getLatLongList([waypoint])[0];
    // const sortedList = itineraryLatLongList.map((latlong: L.LatLng, index: number) => {
    //   return {
    //     distance: this.map.distance(clickedCoordinates, latlong),
    //     waypointIndex: index
    //   };
    // }).sort((item1, item2) => {
    //   return item1.distance - item2.distance;
    // })
    let insertIndex;
    if (this.selectedMarker >= 0) {
      insertIndex = this.currentItineraryDetails.length ? (this.selectedMarker + 1) : 0;
      this.selectedMarker = insertIndex;
    } else {
      insertIndex = this.currentItineraryDetails.length ? (this.currentItineraryDetails.length + 1) : 0;
    }
    waypoint.id = waypoint.sequenceId = insertIndex;
    this.itineraryToBeAdded = waypoint;
    this.addItineraryHandler();
  }

  /**Output event emitted by search component */ 
  getSearchedMarkerData(waypoint: IWayPoint) {
    this.setMarker(true, waypoint);
  }
  /**Output event emitted by `Map-route` */
  hideRouteSummaryTemplate(event: boolean) {
    if (event) {
      const element = this.hostElement.nativeElement.querySelector(
        ".leaflet-right"
      );
      element.setAttribute('style', 'display:none');

    }
  }
  /**Output event from `Map-route`
   * to  handle the new waypoint to be inserted
   * at the specified index of ITINERARY TABLE
   */
  getWaypointToBeAdded(waypoint: any) {
    this.itineraryToBeAdded = waypoint;
    this.addToItinerary();
  }
  onMapReady(map: L.Map) {
    this.map = map;
    this.map=map.invalidateSize();
    this.map.addControl(L.control.zoom({ position: 'bottomleft' }));
    this.map.on('popupopen', () => {
      const element = this.hostElement.nativeElement.querySelector("#addItinerary");
      if (element) {
        element.addEventListener('click', (event: any) => {
          event.preventDefault();
          this.addItineraryHandler();
          
        })
      }
    });

  }

  private setMarker(removeMarker: boolean, displayLocation: IWayPoint, indexNumber?: number) {//
    if (removeMarker) { this.removeAllMarker(); }
    const { latitude, longitude, itineraryName } = displayLocation;
    this.itineraryToBeAdded = displayLocation;
    this.tooltipContent = itineraryName;
    this.popUpContent = this.mapMarker.generatePopupContent(latitude, longitude, itineraryName, true, indexNumber);//
    this.centerMapBasedOnLatLng(latitude, longitude);
    this.addMarker(parseFloat(latitude), parseFloat(longitude));
  }

  private centerMapBasedOnLatLng(lat: any, long: any): void {
    this.map.panTo(latLng(lat, long))
  }

  private removeAllMarker() {
    for (const marker of this.markerList) {
      this.map.removeLayer(marker);
    }
  }

  private initializeMapOptions(lat: number, long: number) {
    this.mapOptions = {
      center: latLng(lat, long),
      zoom: 14,
      maxZoom: 18,
      zoomControl: false,
      layers: [
        this.baseMapTileLayer
      ]
    };

  }


  private addMarker(lat: number, long: number) {
    const marker = this.mapMarker.generateMarker(lat, long, this.tooltipContent, this.popUpContent);
    this.markerList.push(marker);
    this.map.addLayer(marker);
    marker.addTo(this.map);
    marker.openPopup();;

  }

  //logout and setting methods
  openSettingsDialog(): void {
    this.settingsDialog.open(MapSettingsDialog, {
      width: '30rem',
      disableClose: true,
    });
  }

  logout(): void {
    let message: string;
    let width: string;
    if (this.fileService.isItinerayChanged) {
      message = "Changes will be lost. Continue anyway?";
      width = "28rem";
    }
    else {
      message = "Are you sure you want to logout?";
      width = "25rem";
    }
    const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
      width,
      data: message,
      disableClose: false
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.saveData) {  
        this.fileService.writeLog("LogOut").subscribe((data:any)=>{

        })      
          this.userService.logout().subscribe(
            (res:any) => {
              this.authService.logout();
              this.router.navigate(['/user/login']);
              this.fileService.tempRoutefile=null;  
            },
            err => {
              console.log('Login Failed',err);
            }
          )     
      
      }
    })
  }

  // getAllLoginUsers(){
  //   this.fileService.getLoginUsers().subscribe((data:any)=>{
  //    var email=data.responseData;
  //    const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
  //    var userid=storedUser.userId
  //    var currentUserName=email.responseData.filter(b => b.userId==userid)[0]    
  //    this.currentUsername=currentUserName;
  //   })
  // }

  openSaveLocallyDialog():void{
      this.exportDialog.open(FileExportSaveLocallyComponent, {
        width: '30rem',
        disableClose :false,
      });
    }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
    this.mapCopyRight="";
  }
  
}

